import { ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';

import geopardTheme from '../shared/themes/geopard';
import configuredRouter from './router';
import '../shared/i18n';

function App() {
  return (
    <ThemeProvider theme={geopardTheme}>
      <RouterProvider router={configuredRouter} />
    </ThemeProvider>
  );
}

export default App;
